import { render, staticRenderFns } from "./AllergenPropagationTree.vue?vue&type=template&id=6ed8b505&scoped=true"
import script from "./AllergenPropagationTree.vue?vue&type=script&lang=ts"
export * from "./AllergenPropagationTree.vue?vue&type=script&lang=ts"
import style0 from "./AllergenPropagationTree.vue?vue&type=style&index=0&id=6ed8b505&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8b505",
  null
  
)

export default component.exports